// === 实时汇率换算工具模块 ===
// === i18n 国际化模块 ===
// 支持中文(zh) / English(en) 切换
const $68c44e7891f10a4f$var$translations = {
    // ===== 通用 =====
    'site.title': {
        zh: "Practical Tools - Markdown\u8F6C\u6362 | \u6C47\u7387\u6362\u7B97",
        en: 'Practical Tools - Markdown Converter | Exchange Rate'
    },
    'site.name': {
        zh: "\uD83D\uDD27 Practical Tools",
        en: "\uD83D\uDD27 Practical Tools"
    },
    'back.home': {
        zh: "\u2190 \u8FD4\u56DE\u9996\u9875",
        en: "\u2190 Back Home"
    },
    'loading': {
        zh: "\u52A0\u8F7D\u4E2D...",
        en: 'Loading...'
    },
    'load.error': {
        zh: "\u52A0\u8F7D\u5931\u8D25: ",
        en: 'Load failed: '
    },
    // ===== 首页 Hero =====
    'hero.title': {
        zh: "\uD83D\uDEE0\uFE0F Practical Tools",
        en: "\uD83D\uDEE0\uFE0F Practical Tools"
    },
    'hero.desc': {
        zh: "\u5B9E\u7528\u5F00\u53D1\u4E0E\u529E\u516C\u5DE5\u5177 \xb7 \u514D\u8D39 \xb7 \u65E0\u9700\u5B89\u88C5 \xb7 \u5373\u5F00\u5373\u7528",
        en: "Practical dev & office tools \xb7 Free \xb7 No install \xb7 Ready to use"
    },
    'hero.stat1': {
        zh: "\uD83D\uDD12 \u6570\u636E\u672C\u5730\u5904\u7406",
        en: "\uD83D\uDD12 Local processing"
    },
    'hero.stat2': {
        zh: "\u26A1 \u5B9E\u65F6\u54CD\u5E94",
        en: "\u26A1 Real-time"
    },
    'hero.stat3': {
        zh: "\uD83D\uDCF1 \u79FB\u52A8\u7AEF\u9002\u914D",
        en: "\uD83D\uDCF1 Mobile friendly"
    },
    // ===== 首页工具卡片 =====
    'tool.mdhtml.title': {
        zh: "MD \u2194 HTML \u8F6C\u6362\u5668",
        en: "MD \u2194 HTML Converter"
    },
    'tool.mdhtml.desc': {
        zh: "Markdown \u4E0E HTML \u53CC\u5411\u8F6C\u6362\uFF0C\u652F\u6301\u5BCC\u5A92\u4F53\u7F16\u8F91\u3001\u56FE\u7247\u7C98\u8D34\u3001\u8868\u683C\u63D2\u5165\u3002\u5BFC\u51FA PDF / Word / HTML / MD / TXT\u3002",
        en: "Bidirectional Markdown \u2194 HTML converter with rich media editing, image paste, tables. Export to PDF / Word / HTML / MD / TXT."
    },
    'tool.mdhtml.tag1': {
        zh: "\u7F16\u8F91\u5668",
        en: 'Editor'
    },
    'tool.mdhtml.tag2': {
        zh: "\u683C\u5F0F\u8F6C\u6362",
        en: 'Converter'
    },
    'tool.exchange.title': {
        zh: "\u5B9E\u65F6\u6C47\u7387\u6362\u7B97",
        en: 'Exchange Rate'
    },
    'tool.exchange.desc': {
        zh: "\u5168\u7403 30+ \u4E3B\u6D41\u8D27\u5E01\u5B9E\u65F6\u6C47\u7387\u8F6C\u6362\uFF0C\u6570\u636E\u6765\u6E90\u6B27\u6D32\u592E\u884C\uFF0C\u652F\u6301\u5FEB\u6377\u91D1\u989D\u8BA1\u7B97\u3002",
        en: 'Real-time exchange rates for 30+ currencies, powered by ECB data. Quick amount presets.'
    },
    'tool.exchange.tag1': {
        zh: "\u91D1\u878D",
        en: 'Finance'
    },
    'tool.exchange.tag2': {
        zh: "\u5B9E\u65F6\u6570\u636E",
        en: 'Live Data'
    },
    'tool.coming.title': {
        zh: "\u66F4\u591A\u5DE5\u5177\u5373\u5C06\u4E0A\u7EBF",
        en: 'More Tools Coming'
    },
    'tool.coming.desc': {
        zh: "\u65F6\u95F4\u6233\u8F6C\u6362\u3001JSON \u683C\u5F0F\u5316\u3001Base64 \u7F16\u89E3\u7801\u3001\u989C\u8272\u8F6C\u6362\u3001\u4E8C\u7EF4\u7801\u751F\u6210\u2026",
        en: "Timestamp converter, JSON formatter, Base64, color converter, QR code\u2026"
    },
    'tool.coming.tag': {
        zh: "\u656C\u8BF7\u671F\u5F85",
        en: 'Coming soon'
    },
    'footer.text': {
        zh: "\xa9 2026 Practical Tools \xb7 \u591A\u6570\u5904\u7406\u5728\u6D4F\u89C8\u5668\u672C\u5730\u5B8C\u6210\uFF0C\u5177\u4F53\u7F51\u7EDC\u8BF7\u6C42\u89C1\u9690\u79C1\u653F\u7B56",
        en: "\xa9 2026 Practical Tools \xb7 Most processing stays in your browser; see Privacy for network requests"
    },
    // ===== MD-HTML 工具 =====
    'mdhtml.import': {
        zh: "\uD83D\uDCE5 \u5BFC\u5165",
        en: "\uD83D\uDCE5 Import"
    },
    'mdhtml.export': {
        zh: "\uD83D\uDCE4 \u5BFC\u51FA",
        en: "\uD83D\uDCE4 Export"
    },
    'mdhtml.clear': {
        zh: "\uD83D\uDDD1\uFE0F \u6E05\u7A7A",
        en: "\uD83D\uDDD1\uFE0F Clear"
    },
    'mdhtml.intro': {
        zh: "# \u6B22\u8FCE\u4F7F\u7528 MD \u2194 HTML \u8F6C\u6362\u5668\n\n\u8F93\u5165 Markdown \u540E\u70B9\u51FB **\u2192\u8F6CHTML** \u5373\u53EF\u5728\u53F3\u4FA7\u770B\u5230\u9884\u89C8\u6548\u679C\uFF01\n\n> \u652F\u6301\u5BCC\u5A92\u4F53\u7F16\u8F91 \xb7 \u7C98\u8D34\u56FE\u7247 \xb7 \u5BFC\u5165\u5BFC\u51FA\u591A\u79CD\u683C\u5F0F",
        en: "# Welcome to MD \u2194 HTML Converter\n\nType Markdown and click **\u2192HTML** to see the preview on the right!\n\n> Rich media editing \xb7 Paste images \xb7 Import/Export multiple formats"
    },
    'mdhtml.md_label': {
        zh: "\uD83D\uDCDD Markdown",
        en: "\uD83D\uDCDD Markdown"
    },
    'mdhtml.html_label': {
        zh: "\uD83C\uDF10 HTML",
        en: "\uD83C\uDF10 HTML"
    },
    'mdhtml.view': {
        zh: "\u9605\u8BFB",
        en: 'View'
    },
    'mdhtml.source': {
        zh: "\u6E90\u7801",
        en: 'Source'
    },
    'mdhtml.to_html': {
        zh: "\u8F6CHTML",
        en: "\u2192HTML"
    },
    'mdhtml.to_md': {
        zh: "\u8F6CMD",
        en: "\u2190MD"
    },
    'mdhtml.md_placeholder': {
        zh: "\u8F93\u5165 Markdown \u6E90\u7801\u2026",
        en: "Type Markdown source\u2026"
    },
    'mdhtml.html_placeholder': {
        zh: "<h1>\u8F93\u5165 HTML \u6E90\u7801\u2026</h1>",
        en: "<h1>Type HTML source\u2026</h1>"
    },
    'mdhtml.md_render_ph': {
        zh: "\u8F93\u5165 Markdown\uFF0C\u6216\u7C98\u8D34\u56FE\u7247\u2026",
        en: "Type Markdown, or paste images\u2026"
    },
    'mdhtml.html_render_ph': {
        zh: "\u53F3\u4FA7\u663E\u793A HTML \u6E32\u67D3\u7ED3\u679C\u2026",
        en: "HTML preview shows here\u2026"
    },
    'mdhtml.import.fmt_md': {
        zh: "\uD83D\uDCDD Markdown",
        en: "\uD83D\uDCDD Markdown"
    },
    'mdhtml.import.fmt_html': {
        zh: "\uD83C\uDF10 HTML",
        en: "\uD83C\uDF10 HTML"
    },
    'mdhtml.import.fmt_txt': {
        zh: "\uD83D\uDCC3 \u7EAF\u6587\u672C",
        en: "\uD83D\uDCC3 Plain Text"
    },
    'mdhtml.import.fmt_word': {
        zh: "\uD83D\uDCD8 Word",
        en: "\uD83D\uDCD8 Word"
    },
    'mdhtml.export.fmt_pdf': {
        zh: "\uD83D\uDCC4 PDF",
        en: "\uD83D\uDCC4 PDF"
    },
    'mdhtml.export.fmt_word': {
        zh: "\uD83D\uDCD8 Word",
        en: "\uD83D\uDCD8 Word"
    },
    'mdhtml.export.fmt_html': {
        zh: "\uD83C\uDF10 HTML",
        en: "\uD83C\uDF10 HTML"
    },
    'mdhtml.export.fmt_md': {
        zh: "\uD83D\uDCDD Markdown",
        en: "\uD83D\uDCDD Markdown"
    },
    'mdhtml.export.fmt_txt': {
        zh: "\uD83D\uDCC3 \u7EAF\u6587\u672C",
        en: "\uD83D\uDCC3 Plain Text"
    },
    'mdhtml.modal.ok': {
        zh: "\u786E\u5B9A",
        en: 'OK'
    },
    'mdhtml.modal.cancel': {
        zh: "\u53D6\u6D88",
        en: 'Cancel'
    },
    'mdhtml.modal.title': {
        zh: "\u5F39\u7A97",
        en: 'Dialog'
    },
    'mdhtml.modal.link': {
        zh: "\uD83D\uDD17 \u63D2\u5165\u94FE\u63A5",
        en: "\uD83D\uDD17 Insert Link"
    },
    'mdhtml.modal.link_text': {
        zh: "\u94FE\u63A5\u6587\u5B57",
        en: 'Link text'
    },
    'mdhtml.modal.link_url': {
        zh: "https://\u2026",
        en: "https://\u2026"
    },
    'mdhtml.modal.code': {
        zh: "\uD83D\uDCBB \u63D2\u5165\u4EE3\u7801\u5757",
        en: "\uD83D\uDCBB Insert Code"
    },
    'mdhtml.modal.code_lang': {
        zh: "\u8BED\u8A00 (js/python/\u2026)",
        en: "Language (js/python/\u2026)"
    },
    'mdhtml.modal.code_ph': {
        zh: "\u8F93\u5165\u4EE3\u7801\u2026",
        en: "Type code\u2026"
    },
    'mdhtml.modal.image': {
        zh: "\uD83D\uDDBC\uFE0F \u63D2\u5165\u56FE\u7247",
        en: "\uD83D\uDDBC\uFE0F Insert Image"
    },
    'mdhtml.modal.table': {
        zh: "\uD83D\uDCCA \u63D2\u5165\u8868\u683C",
        en: "\uD83D\uDCCA Insert Table"
    },
    'mdhtml.modal.rows': {
        zh: "\u884C\u6570",
        en: 'Rows'
    },
    'mdhtml.modal.cols': {
        zh: "\u5217\u6570",
        en: 'Cols'
    },
    'mdhtml.modal.col_label': {
        zh: "\u5217",
        en: 'Col'
    },
    'mdhtml.modal.cell': {
        zh: "\u5185\u5BB9",
        en: 'Content'
    },
    'mdhtml.toast.no_md': {
        zh: "\u26A0\uFE0F \u8BF7\u5148\u8F93\u5165 Markdown",
        en: "\u26A0\uFE0F Please enter Markdown first"
    },
    'mdhtml.toast.no_html': {
        zh: "\u26A0\uFE0F \u8BF7\u5148\u8F93\u5165 HTML",
        en: "\u26A0\uFE0F Please enter HTML first"
    },
    'mdhtml.toast.no_export': {
        zh: "\u26A0\uFE0F \u6CA1\u6709\u5185\u5BB9",
        en: "\u26A0\uFE0F No content"
    },
    'mdhtml.toast.md2html': {
        zh: "MD \u2192 HTML \u2705",
        en: "MD \u2192 HTML \u2705"
    },
    'mdhtml.toast.html2md': {
        zh: "HTML \u2192 MD \u2705",
        en: "HTML \u2192 MD \u2705"
    },
    'mdhtml.toast.importing': {
        zh: "\u6B63\u5728\u5BFC\u5165\u2026",
        en: "Importing\u2026"
    },
    'mdhtml.toast.imported': {
        zh: "\uD83D\uDCE5 \u5DF2\u5BFC\u5165: ",
        en: "\uD83D\uDCE5 Imported: "
    },
    'mdhtml.toast.import_err': {
        zh: "\u5BFC\u5165\u5931\u8D25 \u274C",
        en: "Import failed \u274C"
    },
    'mdhtml.toast.pdf': {
        zh: "PDF \u5DF2\u5BFC\u51FA \uD83D\uDCC4",
        en: "PDF exported \uD83D\uDCC4"
    },
    'mdhtml.toast.word': {
        zh: "Word \u5DF2\u5BFC\u51FA \uD83D\uDCE4",
        en: "Word exported \uD83D\uDCE4"
    },
    'mdhtml.toast.html': {
        zh: "HTML \u5DF2\u5BFC\u51FA \uD83C\uDF10",
        en: "HTML exported \uD83C\uDF10"
    },
    'mdhtml.toast.md': {
        zh: "MD \u5DF2\u5BFC\u51FA \uD83D\uDCDD",
        en: "MD exported \uD83D\uDCDD"
    },
    'mdhtml.toast.txt': {
        zh: "TXT \u5DF2\u5BFC\u51FA \uD83D\uDCC3",
        en: "TXT exported \uD83D\uDCC3"
    },
    'mdhtml.toast.pdf_gen': {
        zh: "\u6B63\u5728\u751F\u6210 PDF\u2026",
        en: "Generating PDF\u2026"
    },
    'mdhtml.toast.word_gen': {
        zh: "\u6B63\u5728\u751F\u6210 Word\u2026",
        en: "Generating Word\u2026"
    },
    'mdhtml.toast.export_err': {
        zh: "\u5BFC\u51FA ",
        en: 'Export '
    },
    'mdhtml.toast.export_err2': {
        zh: " \u5931\u8D25 \u274C",
        en: " failed \u274C"
    },
    'mdhtml.confirm_clear': {
        zh: "\u786E\u5B9A\u6E05\u7A7A\uFF1F",
        en: 'Clear all content?'
    },
    // ===== 汇率工具 =====
    'rate.title': {
        zh: "\uD83D\uDCB1 \u5B9E\u65F6\u6C47\u7387\u6362\u7B97",
        en: "\uD83D\uDCB1 Exchange Rate"
    },
    'rate.source': {
        zh: "\u6570\u636E\u6765\u6E90: \u6B27\u6D32\u592E\u884C",
        en: 'Source: ECB'
    },
    'rate.amount_ph': {
        zh: "\u8F93\u5165\u91D1\u989D",
        en: 'Amount'
    },
    'rate.swap': {
        zh: "\u21C5 \u4EA4\u6362\u8D27\u5E01",
        en: "\u21C5 Swap"
    },
    'rate.result_label': {
        zh: "\u8F6C\u6362\u7ED3\u679C",
        en: 'Result'
    },
    'rate.calculating': {
        zh: "\u8BA1\u7B97\u4E2D\u2026",
        en: "Calculating\u2026"
    },
    'rate.error': {
        zh: "\u83B7\u53D6\u5931\u8D25",
        en: 'Failed'
    },
    'rate.network_err': {
        zh: "\u7F51\u7EDC\u5F02\u5E38\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
        en: 'Network error, try again later'
    },
    'rate.disclaimer': {
        zh: "\u6C47\u7387\u6570\u636E\u6BCF\u65E5\u66F4\u65B0\uFF0C\u4EC5\u4F9B\u53C2\u8003\uFF0C\u5B9E\u9645\u4EA4\u6613\u4EE5\u94F6\u884C\u67DC\u53F0\u4E3A\u51C6",
        en: 'Exchange rates updated daily, for reference only.'
    },
    'rate.credit': {
        zh: "\u6570\u636E\u7531 frankfurter.app \u63D0\u4F9B (\u6B27\u6D32\u592E\u884C)",
        en: 'Data by frankfurter.app (ECB)'
    },
    'rate.updated': {
        zh: "\u6570\u636E\u66F4\u65B0: ",
        en: 'Updated: '
    },
    'rate.updated_src': {
        zh: " \xb7 \u6765\u6E90: \u6B27\u6D32\u592E\u884C",
        en: " \xb7 Source: ECB"
    },
    'rate.cached': {
        zh: "\u26A0\uFE0F \u4F7F\u7528\u7F13\u5B58\u6570\u636E (\u7F51\u7EDC\u5F02\u5E38)",
        en: "\u26A0\uFE0F Using cached data (offline)"
    },
    // ===== 语言切换 =====
    'lang.switch': {
        zh: 'EN',
        en: "\u4E2D\u6587"
    },
    'lang.label': {
        zh: "\u8BED\u8A00",
        en: 'Language'
    }
};
// 通过 localStorage 获取/设置语言
const $68c44e7891f10a4f$var$LANG_KEY = 'web-tools-lang';
function $68c44e7891f10a4f$var$detectLang() {
    const saved = localStorage.getItem($68c44e7891f10a4f$var$LANG_KEY);
    if (saved === 'zh' || saved === 'en') return saved;
    // 默认跟随浏览器语言
    const nav = navigator.language || '';
    return nav.startsWith('zh') ? 'zh' : 'en';
}
let $68c44e7891f10a4f$var$currentLang = $68c44e7891f10a4f$var$detectLang();
function $68c44e7891f10a4f$export$625550452a3fa3ec(key) {
    const entry = $68c44e7891f10a4f$var$translations[key];
    if (!entry) return key;
    return entry[$68c44e7891f10a4f$var$currentLang] || entry['en'] || key;
}
function $68c44e7891f10a4f$export$dec8f99c0c14e178() {
    return $68c44e7891f10a4f$var$currentLang;
}
function $68c44e7891f10a4f$export$a3665b844fbc095d(lang) {
    if (lang !== 'zh' && lang !== 'en') return;
    $68c44e7891f10a4f$var$currentLang = lang;
    localStorage.setItem($68c44e7891f10a4f$var$LANG_KEY, lang);
    // 通知订阅者
    $68c44e7891f10a4f$var$listeners.forEach((fn)=>fn(lang));
}
const $68c44e7891f10a4f$var$listeners = [];
function $68c44e7891f10a4f$export$18c6e7c9e91e1c0f(fn) {
    $68c44e7891f10a4f$var$listeners.push(fn);
}
function $68c44e7891f10a4f$export$300b068eecd7c850(root = document) {
    root.querySelectorAll('[data-i18n]').forEach((el)=>{
        const key = el.dataset.i18n;
        el.textContent = $68c44e7891f10a4f$export$625550452a3fa3ec(key);
    });
    root.querySelectorAll('[data-i18n-placeholder]').forEach((el)=>{
        const key = el.dataset.i18nPlaceholder;
        el.placeholder = $68c44e7891f10a4f$export$625550452a3fa3ec(key);
    });
    root.querySelectorAll('[data-i18n-title]').forEach((el)=>{
        const key = el.dataset.i18nTitle;
        el.title = $68c44e7891f10a4f$export$625550452a3fa3ec(key);
    });
    // 更新 title
    const titleEl = root.querySelector('title');
    if (titleEl && titleEl.dataset.i18n) document.title = $68c44e7891f10a4f$export$625550452a3fa3ec(titleEl.dataset.i18n);
    else if (titleEl) document.title = $68c44e7891f10a4f$export$625550452a3fa3ec('site.title');
}


// 数据来源（多源fallback）
const $cde4b4fc23b54d72$var$API_SOURCES = [
    'https://api.frankfurter.app',
    'https://open.er-api.com/v6'
];
// 离线备用汇率（2024基准，相对美元）
const $cde4b4fc23b54d72$var$FALLBACK_RATES = {
    USD: 1,
    CNY: 7.24,
    EUR: 0.92,
    JPY: 155.8,
    GBP: 0.79,
    HKD: 7.82,
    KRW: 1370,
    AUD: 1.53,
    CAD: 1.37,
    CHF: 0.89,
    SGD: 1.34,
    TWD: 32.1,
    INR: 83.5,
    RUB: 90.2,
    BRL: 5.12,
    MXN: 17.2,
    THB: 36.5,
    MYR: 4.68,
    PHP: 57.2,
    IDR: 16100,
    VND: 24800,
    NZD: 1.64,
    SEK: 10.5,
    NOK: 10.7,
    DKK: 6.88,
    TRY: 32.5,
    ZAR: 18.3,
    AED: 3.67
};
// 常用货币列表
const $cde4b4fc23b54d72$var$CURRENCIES = [
    {
        code: 'CNY',
        name: "\u4EBA\u6C11\u5E01",
        symbol: "\xa5",
        flag: "\uD83C\uDDE8\uD83C\uDDF3"
    },
    {
        code: 'USD',
        name: "\u7F8E\u5143",
        symbol: '$',
        flag: "\uD83C\uDDFA\uD83C\uDDF8"
    },
    {
        code: 'EUR',
        name: "\u6B27\u5143",
        symbol: "\u20AC",
        flag: "\uD83C\uDDEA\uD83C\uDDFA"
    },
    {
        code: 'JPY',
        name: "\u65E5\u5143",
        symbol: "\xa5",
        flag: "\uD83C\uDDEF\uD83C\uDDF5"
    },
    {
        code: 'GBP',
        name: "\u82F1\u9551",
        symbol: "\xa3",
        flag: "\uD83C\uDDEC\uD83C\uDDE7"
    },
    {
        code: 'HKD',
        name: "\u6E2F\u5E01",
        symbol: 'HK$',
        flag: "\uD83C\uDDED\uD83C\uDDF0"
    },
    {
        code: 'KRW',
        name: "\u97E9\u5143",
        symbol: "\u20A9",
        flag: "\uD83C\uDDF0\uD83C\uDDF7"
    },
    {
        code: 'AUD',
        name: "\u6FB3\u5143",
        symbol: 'A$',
        flag: "\uD83C\uDDE6\uD83C\uDDFA"
    },
    {
        code: 'CAD',
        name: "\u52A0\u5143",
        symbol: 'C$',
        flag: "\uD83C\uDDE8\uD83C\uDDE6"
    },
    {
        code: 'CHF',
        name: "\u745E\u58EB\u6CD5\u90CE",
        symbol: 'CHF',
        flag: "\uD83C\uDDE8\uD83C\uDDED"
    },
    {
        code: 'SGD',
        name: "\u65B0\u52A0\u5761\u5143",
        symbol: 'S$',
        flag: "\uD83C\uDDF8\uD83C\uDDEC"
    },
    {
        code: 'TWD',
        name: "\u65B0\u53F0\u5E01",
        symbol: 'NT$',
        flag: "\uD83C\uDDF9\uD83C\uDDFC"
    },
    {
        code: 'INR',
        name: "\u5370\u5EA6\u5362\u6BD4",
        symbol: "\u20B9",
        flag: "\uD83C\uDDEE\uD83C\uDDF3"
    },
    {
        code: 'RUB',
        name: "\u5362\u5E03",
        symbol: "\u20BD",
        flag: "\uD83C\uDDF7\uD83C\uDDFA"
    },
    {
        code: 'BRL',
        name: "\u5DF4\u897F\u96F7\u4E9A\u5C14",
        symbol: 'R$',
        flag: "\uD83C\uDDE7\uD83C\uDDF7"
    },
    {
        code: 'MXN',
        name: "\u58A8\u897F\u54E5\u6BD4\u7D22",
        symbol: 'Mex$',
        flag: "\uD83C\uDDF2\uD83C\uDDFD"
    },
    {
        code: 'THB',
        name: "\u6CF0\u94E2",
        symbol: "\u0E3F",
        flag: "\uD83C\uDDF9\uD83C\uDDED"
    },
    {
        code: 'MYR',
        name: "\u9A6C\u6765\u897F\u4E9A\u6797\u5409\u7279",
        symbol: 'RM',
        flag: "\uD83C\uDDF2\uD83C\uDDFE"
    },
    {
        code: 'PHP',
        name: "\u83F2\u5F8B\u5BBE\u6BD4\u7D22",
        symbol: "\u20B1",
        flag: "\uD83C\uDDF5\uD83C\uDDED"
    },
    {
        code: 'IDR',
        name: "\u5370\u5C3C\u76FE",
        symbol: 'Rp',
        flag: "\uD83C\uDDEE\uD83C\uDDE9"
    },
    {
        code: 'VND',
        name: "\u8D8A\u5357\u76FE",
        symbol: "\u20AB",
        flag: "\uD83C\uDDFB\uD83C\uDDF3"
    },
    {
        code: 'NZD',
        name: "\u65B0\u897F\u5170\u5143",
        symbol: 'NZ$',
        flag: "\uD83C\uDDF3\uD83C\uDDFF"
    },
    {
        code: 'SEK',
        name: "\u745E\u5178\u514B\u6717",
        symbol: 'kr',
        flag: "\uD83C\uDDF8\uD83C\uDDEA"
    },
    {
        code: 'NOK',
        name: "\u632A\u5A01\u514B\u6717",
        symbol: 'kr',
        flag: "\uD83C\uDDF3\uD83C\uDDF4"
    },
    {
        code: 'DKK',
        name: "\u4E39\u9EA6\u514B\u6717",
        symbol: 'kr',
        flag: "\uD83C\uDDE9\uD83C\uDDF0"
    },
    {
        code: 'TRY',
        name: "\u571F\u8033\u5176\u91CC\u62C9",
        symbol: "\u20BA",
        flag: "\uD83C\uDDF9\uD83C\uDDF7"
    },
    {
        code: 'ZAR',
        name: "\u5357\u975E\u5170\u7279",
        symbol: 'R',
        flag: "\uD83C\uDDFF\uD83C\uDDE6"
    },
    {
        code: 'AED',
        name: "\u963F\u8054\u914B\u8FEA\u62C9\u59C6",
        symbol: "\u062F.\u0625",
        flag: "\uD83C\uDDE6\uD83C\uDDEA"
    }
];
// 缓存汇率 (5分钟有效)
let $cde4b4fc23b54d72$var$rateCache = {
    from: null,
    to: null,
    rate: null,
    timestamp: 0
};
const $cde4b4fc23b54d72$var$CACHE_TTL = 300000;
function $cde4b4fc23b54d72$export$b3890eb0ae9dca99(container) {
    container.innerHTML = '';
    const currencyOptions = $cde4b4fc23b54d72$var$CURRENCIES.map((c)=>`<option value="${c.code}">${c.flag} ${c.code} - ${c.name}</option>`).join('');
    const html = `
    <div class="rate-container">
      <div class="rate-card">
        <h2>${(0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.title')}</h2>
        <div class="rate-updated" id="rateUpdated">${(0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.source')}</div>

        <!-- \u{8F93}\u{5165}\u{91D1}\u{989D} -->
        <div class="rate-input-group">
          <input type="number" id="rateAmount" class="rate-amount" value="1" min="0" step="any" placeholder="${(0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.amount_ph')}" />
          <select id="rateFrom" class="rate-select">${currencyOptions}</select>
        </div>

        <!-- \u{4EA4}\u{6362}\u{6309}\u{94AE} -->
        <div class="rate-swap-row">
          <button id="rateSwap" class="rate-swap-btn">${(0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.swap')}</button>
        </div>

        <!-- \u{76EE}\u{6807}\u{8D27}\u{5E01} -->
        <div class="rate-input-group">
          <select id="rateTo" class="rate-select">${currencyOptions}</select>
          <div class="rate-amount" id="rateOutput" style="display:flex;align-items:center;justify-content:center;cursor:default;">\u{2014}</div>
        </div>

        <!-- \u{8F6C}\u{6362}\u{7ED3}\u{679C} -->
        <div class="rate-result">
          <div class="rate-result-label">${(0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.result_label')}</div>
          <div class="rate-result-value" id="rateResult">\u{2014}</div>
          <div class="rate-result-rate" id="rateInfo"></div>
        </div>

        <!-- \u{5FEB}\u{6377}\u{91D1}\u{989D} -->
        <div class="rate-presets">
          <button class="rate-preset" data-amt="1">1</button>
          <button class="rate-preset" data-amt="10">10</button>
          <button class="rate-preset" data-amt="100">100</button>
          <button class="rate-preset" data-amt="500">500</button>
          <button class="rate-preset" data-amt="1000">1,000</button>
          <button class="rate-preset" data-amt="10000">10,000</button>
        </div>
      </div>

      <!-- \u{5E95}\u{90E8}\u{4FE1}\u{606F} -->
      <div style="text-align:center;padding:16px;color:#484f58;font-size:.75rem;">
        <p>${(0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.disclaimer')}</p>
        <p style="margin-top:4px;">${(0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.credit')}</p>
      </div>
    </div>
  `;
    container.innerHTML = html;
    // ---- DOM refs ----
    const $ = (id)=>document.getElementById(id);
    const amountInput = $('rateAmount');
    const fromSelect = $('rateFrom');
    const toSelect = $('rateTo');
    const outputDisplay = $('rateOutput');
    const resultValue = $('rateResult');
    const rateInfo = $('rateInfo');
    const rateUpdated = $('rateUpdated');
    // 默认值
    fromSelect.value = 'CNY';
    toSelect.value = 'USD';
    // ---- 获取汇率（多源fallback） ----
    async function getRate(from, to) {
        if (from === to) return 1;
        // 检查缓存
        if ($cde4b4fc23b54d72$var$rateCache.from === from && $cde4b4fc23b54d72$var$rateCache.to === to && Date.now() - $cde4b4fc23b54d72$var$rateCache.timestamp < $cde4b4fc23b54d72$var$CACHE_TTL) return $cde4b4fc23b54d72$var$rateCache.rate;
        let lastErr = null;
        // 尝试多个 API 源
        for (const baseUrl of $cde4b4fc23b54d72$var$API_SOURCES)try {
            let url;
            if (baseUrl.includes('frankfurter')) url = `${baseUrl}/latest?from=${from}&to=${to}`;
            else // open.er-api.com 格式不同
            url = `${baseUrl}/latest/${from}`;
            const resp = await fetch(url, {
                signal: AbortSignal.timeout(5000)
            });
            if (!resp.ok) continue;
            const data = await resp.json();
            let rate;
            if (data.rates) rate = data.rates[to];
            if (!rate) continue;
            $cde4b4fc23b54d72$var$rateCache = {
                from: from,
                to: to,
                rate: rate,
                timestamp: Date.now()
            };
            rateUpdated.textContent = (0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.updated') + (data.date || new Date().toISOString().slice(0, 10)) + (0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.updated_src');
            return rate;
        } catch (err) {
            lastErr = err;
            continue;
        }
        // 所有API都失败 → 使用离线备用数据
        if ($cde4b4fc23b54d72$var$FALLBACK_RATES[from] && $cde4b4fc23b54d72$var$FALLBACK_RATES[to]) {
            const rate = $cde4b4fc23b54d72$var$FALLBACK_RATES[to] / $cde4b4fc23b54d72$var$FALLBACK_RATES[from];
            $cde4b4fc23b54d72$var$rateCache = {
                from: from,
                to: to,
                rate: rate,
                timestamp: Date.now()
            };
            rateUpdated.textContent = (0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.cached');
            return rate;
        }
        // 彻底失败
        if ($cde4b4fc23b54d72$var$rateCache.rate && $cde4b4fc23b54d72$var$rateCache.from === from && $cde4b4fc23b54d72$var$rateCache.to === to) {
            rateUpdated.textContent = (0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.cached');
            return $cde4b4fc23b54d72$var$rateCache.rate;
        }
        throw lastErr || new Error("\u6240\u6709\u6570\u636E\u6E90\u4E0D\u53EF\u7528");
    }
    // ---- 执行换算 ----
    async function convert() {
        const from = fromSelect.value;
        const to = toSelect.value;
        const amount = parseFloat(amountInput.value) || 0;
        if (amount <= 0) {
            resultValue.textContent = "\u2014";
            outputDisplay.textContent = "\u2014";
            rateInfo.textContent = '';
            return;
        }
        resultValue.textContent = (0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.calculating');
        outputDisplay.textContent = (0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.calculating');
        try {
            const rate = await getRate(from, to);
            const result = amount * rate;
            const fromCur = $cde4b4fc23b54d72$var$CURRENCIES.find((c)=>c.code === from);
            const toCur = $cde4b4fc23b54d72$var$CURRENCIES.find((c)=>c.code === to);
            resultValue.textContent = formatNumber(result);
            outputDisplay.textContent = formatNumber(result);
            const fromLabel = fromCur ? `${fromCur.flag} ${fromCur.code}` : from;
            const toLabel = toCur ? `${toCur.flag} ${toCur.code}` : to;
            rateInfo.textContent = `1 ${fromLabel} = ${formatNumber(rate)} ${toLabel}`;
        } catch (err) {
            resultValue.textContent = (0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.error');
            outputDisplay.textContent = "\u26A0\uFE0F";
            rateInfo.textContent = (0, $68c44e7891f10a4f$export$625550452a3fa3ec)('rate.network_err');
            resultValue.style.color = '#f85149';
            setTimeout(()=>{
                resultValue.style.color = '';
            }, 3000);
        }
    }
    function formatNumber(n) {
        if (Math.abs(n) < 0.01 && n !== 0) return n.toFixed(6);
        if (Math.abs(n) < 1) return n.toFixed(4);
        if (Math.abs(n) < 1000) return n.toFixed(2);
        return n.toLocaleString('zh-CN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
    // ---- 事件绑定 ----
    let convertTimer = null;
    function debounceConvert() {
        clearTimeout(convertTimer);
        convertTimer = setTimeout(convert, 300);
    }
    amountInput.addEventListener('input', debounceConvert);
    fromSelect.addEventListener('change', convert);
    toSelect.addEventListener('change', convert);
    // 交换货币
    $('rateSwap').addEventListener('click', ()=>{
        const tmp = fromSelect.value;
        fromSelect.value = toSelect.value;
        toSelect.value = tmp;
        convert();
    });
    // 快捷金额
    document.querySelectorAll('.rate-preset').forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            amountInput.value = btn.dataset.amt;
            convert();
        });
    });
    // 初始加载
    convert();
}
// 自动初始化：如果页面有 #app 容器则自动渲染
const $cde4b4fc23b54d72$var$appEl = document.getElementById('app');
if ($cde4b4fc23b54d72$var$appEl) $cde4b4fc23b54d72$export$b3890eb0ae9dca99($cde4b4fc23b54d72$var$appEl);


//# sourceMappingURL=exchange-rate.309b736a.js.map
